import { IconModule } from "../icon/icon.module";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CheckboxComponent } from "./checkbox.component";

@NgModule({
	declarations: [CheckboxComponent],
	imports: [CommonModule, FormsModule, IconModule],
	exports: [CheckboxComponent]
})
export class CheckboxModule { }
